import React from "react";
import { Ban } from "lucide-react";

// Badge rouge "Bloqué" affiché à côté du nom d'un dossier bloqué (litige de
// recouvrement) dans les suivis de production. La classe `badge-bloque` le
// soustrait au grisage de la ligne (voir .ligne-bloquee dans Suivi.css).
function BadgeBloque() {
  return (
    <span
      title="Dossier bloqué"
      className="badge-bloque inline-flex items-center gap-1 ml-2 px-1.5 py-0.5 rounded-full bg-red-100 text-red-700 border border-red-200 text-[9px] font-semibold leading-none align-middle"
    >
      <Ban className="w-2.5 h-2.5" />
      Bloqué
    </span>
  );
}

export default BadgeBloque;
